import template from './overachievers-report.html';
import controller from './overachievers-report.controller';

let overachieversReportComponent = {
  restrict: 'E',
  template,
  controller
};

export default overachieversReportComponent;



// WEBPACK FOOTER //
// ./client/pages/admin/reports/canned-reports/overachievers-report/overachievers-report.component.js